import { ApostatudoApiFetchStoriesAdapter } from './api-fetch-stories/apostatudo-api-fetch-stories.adapter';
import { ApostatudoApiRegisterUserJourneyEventAdapter } from './api-register-user-journey-event/apostatudo-api-register-user-journey-event.adapter';
import { FingerprintJsDeviceFingerprintAdapter } from './device-fingerprint/fingerprintjs-device-fingerprint.adapter';
import { ApostatudoApiFetchLastGamesAdapter } from './api-fetch-last-games/apostatudo-api-fetch-last-games.adapter';
import { ApostatudoApiUpdateLastGamesAdapter } from './api-update-last-games/apostatudo-api-update-last-games.adapter';
import { ApostatudoApiFetchBannersAdapter } from './api-fetch-banners/apostatudo-api-fetch-banners.adapter';
import { ApostatudoApiFetchHomeSectionsAdapter } from './api-fetch-home-sections/apostatudo-api-fetch-home-sections.adapter';
import { ApostatudoApiFetchGameFiltersAdapter } from './api-fetch-game-filters/apostatudo-api-fetch-game-filters.adapter';
import { ApostatudoApiFetchGameFilterOptionsAdapter } from './api-fetch-game-filter-options/apostatudo-api-fetch-game-filter-options.adapter';
import { ApostatudoApiFetchPerfilOficialBannersAdapter } from './api-fetch-perfil-oficial-banners/apostatudo-api-fetch-perfil-oficial-banners.adapter';
import { ApostatudoApiFetchHomeMenuAdapter } from './api-fetch-home-menu/apostatudo-api-fetch-home-menu.adapter';
import { ApostatudoApiFetchCuratedEventsAdapter } from './api-fetch-curated-events/apostatudo-api-fetch-curated-events.adapter';
import { ApostatudoApiFetchFaqAdapter } from './api-fetch-faq/apostatudo-api-fetch-faq.adapter';
import { ApostatudoApiFetchBlogPostsAdapter } from './api-fetch-blog/apostatudo-api-fetch-blog-posts.adapter';
import { ApostatudoApiFetchBlogPostAdapter } from './api-fetch-blog/apostatudo-api-fetch-blog-post.adapter';
import { ApostatudoApiRedeemPromocodeAdapter } from './api-redeem-promocode/apostatudo-api-redeem-promocode.adapter';
import { ApostatudoApiSmarticoProfileEventAdapter } from './api-smartico-profile-event/apostatudo-api-smartico-profile-event.adapter';
import { ApostatudoApiFetchRoulettesAdapter } from './api-roulette/apostatudo-api-fetch-roulettes.adapter';
import { ApostatudoApiFetchRouletteDetailAdapter } from './api-roulette/apostatudo-api-fetch-roulette-detail.adapter';
import { ApostatudoApiPostRouletteSpinAdapter } from './api-roulette/apostatudo-api-post-roulette-spin.adapter';
import { ApostatudoApiFetchRoulettePrizeHistoryAdapter } from './api-roulette/apostatudo-api-fetch-roulette-prize-history.adapter';
import { ApostatudoApiFetchLoyaltyHubAdapter } from './api-loyalty-hub/apostatudo-api-fetch-loyalty-hub.adapter';
import { ApostatudoApiFetchDailyCheckinAdapter } from './api-daily-checkin/apostatudo-api-fetch-daily-checkin.adapter';
import { ApostatudoApiPostDailyCheckinClaimAdapter } from './api-daily-checkin/apostatudo-api-post-daily-checkin-claim.adapter';
import { ApostatudoApiFetchPlayerProfileAdapter } from './api-player-profile/apostatudo-api-fetch-player-profile.adapter';
import { ApostatudoApiFetchOfficialProfilesAdapter } from './api-official-profiles/apostatudo-api-fetch-official-profiles.adapter';
import { ApostatudoApiFetchOfficialProfileAdapter } from './api-official-profiles/apostatudo-api-fetch-official-profile.adapter';
import { ApostatudoApiFetchCategoryGamesAdapter } from './api-official-profiles/apostatudo-api-fetch-category-games.adapter';
import { ApostatudoApiPostSyncCrmLevelAdapter } from './api-sync-crm-level/apostatudo-api-post-sync-crm-level.adapter';
import { ApostatudoApiFetchCrashPreGameAdapter } from './api-crash/apostatudo-api-fetch-crash-pre-game.adapter';
import { ApostatudoApiFetchSiteStatusAdapter } from './api-fetch-site-status/apostatudo-api-fetch-site-status.adapter';
import type { ApiRegisterUserJourneyEventPort } from '~/handlers/ports/api-register-user-journey-event.port';
import type { DeviceFingerprintPort } from '~/handlers/ports/device-fingerprint.port';
import type { ApiFetchStoriesPort } from '~/handlers/ports/api-fetch-stories.port';
import type { ApiFetchLastGamesPort } from '~/handlers/ports/api-fetch-last-games.port';
import type { ApiUpdateLastGamesPort } from '~/handlers/ports/api-update-last-games.port';
import type { ApiFetchBannersPort } from '~/handlers/ports/api-fetch-banners.port';
import type { ApiFetchHomeSectionsPort } from '~/handlers/ports/api-fetch-home-sections.port';
import type { ApiFetchGameFiltersPort } from '~/handlers/ports/api-fetch-game-filters.port';
import type { ApiFetchGameFilterOptionsPort } from '~/handlers/ports/api-fetch-game-filter-options.port';
import type { ApiFetchPerfilOficialBannersPort } from '~/handlers/ports/api-fetch-perfil-oficial-banners.port';
import type { ApiFetchHomeMenuPort } from '~/handlers/ports/api-fetch-home-menu.port';
import type { ApiFetchCuratedEventsPort } from '~/handlers/ports/api-fetch-curated-events.port';
import type { ApiFetchFaqPort } from '~/handlers/ports/api-fetch-faq.port';
import type { ApiFetchBlogPostsPort } from '~/handlers/ports/api-fetch-blog-posts.port';
import type { ApiFetchBlogPostPort } from '~/handlers/ports/api-fetch-blog-post.port';
import type { ApiRedeemPromocodePort } from '~/handlers/ports/api-redeem-promocode.port';
import type { ApiSmarticoProfileEventPort } from '~/handlers/ports/api-smartico-profile-event.port';
import type { ApiFetchRoulettesPort } from '~/handlers/ports/api-fetch-roulettes.port';
import type { ApiFetchRouletteDetailPort } from '~/handlers/ports/api-fetch-roulette-detail.port';
import type { ApiPostRouletteSpinPort } from '~/handlers/ports/api-post-roulette-spin.port';
import type { ApiFetchRoulettePrizeHistoryPort } from '~/handlers/ports/api-fetch-roulette-prize-history.port';
import type { ApiFetchLoyaltyHubPort } from '~/handlers/ports/api-fetch-loyalty-hub.port';
import type { ApiFetchDailyCheckinPort } from '~/handlers/ports/api-fetch-daily-checkin.port';
import type { ApiPostDailyCheckinClaimPort } from '~/handlers/ports/api-post-daily-checkin-claim.port';
import type { ApiFetchPlayerProfilePort } from '~/handlers/ports/api-fetch-player-profile.port';
import type { ApiFetchOfficialProfilesPort } from '~/handlers/ports/api-fetch-official-profiles.port';
import type { ApiFetchOfficialProfilePort } from '~/handlers/ports/api-fetch-official-profile.port';
import type { ApiFetchCategoryGamesPort } from '~/handlers/ports/api-fetch-category-games.port';
import type { ApiSyncCrmLevelPort } from '~/handlers/ports/api-sync-crm-level.port';
import type { ApiFetchCrashPreGamePort } from '~/handlers/ports/api-fetch-crash-pre-game.port';
import type { ApiFetchSiteStatusPort } from '~/handlers/ports/api-fetch-site-status.port';

export const adapterRegistry: Record<string, unknown> = {
  apiFetchStories: new ApostatudoApiFetchStoriesAdapter(),
  apiRegisterUserJourneyEvent:
    new ApostatudoApiRegisterUserJourneyEventAdapter(),
  deviceFingerprint: new FingerprintJsDeviceFingerprintAdapter(),
  apiFetchLastGames: new ApostatudoApiFetchLastGamesAdapter(),
  apiUpdateLastGames: new ApostatudoApiUpdateLastGamesAdapter(),
  apiFetchBanners: new ApostatudoApiFetchBannersAdapter(),
  apiFetchHomeSections: new ApostatudoApiFetchHomeSectionsAdapter(),
  apiFetchGameFilters: new ApostatudoApiFetchGameFiltersAdapter(),
  apiFetchGameFilterOptions: new ApostatudoApiFetchGameFilterOptionsAdapter(),
  apiFetchPerfilOficialBanners:
    new ApostatudoApiFetchPerfilOficialBannersAdapter(),
  apiFetchHomeMenu: new ApostatudoApiFetchHomeMenuAdapter(),
  apiFetchCuratedEvents: new ApostatudoApiFetchCuratedEventsAdapter(),
  apiFetchFaq: new ApostatudoApiFetchFaqAdapter(),
  apiFetchBlogPosts: new ApostatudoApiFetchBlogPostsAdapter(),
  apiFetchBlogPost: new ApostatudoApiFetchBlogPostAdapter(),
  apiRedeemPromocode: new ApostatudoApiRedeemPromocodeAdapter(),
  apiSmarticoProfileEvent: new ApostatudoApiSmarticoProfileEventAdapter(),
  apiFetchRoulettes: new ApostatudoApiFetchRoulettesAdapter(),
  apiFetchRouletteDetail: new ApostatudoApiFetchRouletteDetailAdapter(),
  apiPostRouletteSpin: new ApostatudoApiPostRouletteSpinAdapter(),
  apiFetchRoulettePrizeHistory:
    new ApostatudoApiFetchRoulettePrizeHistoryAdapter(),
  apiFetchLoyaltyHub: new ApostatudoApiFetchLoyaltyHubAdapter(),
  apiFetchDailyCheckin: new ApostatudoApiFetchDailyCheckinAdapter(),
  apiPostDailyCheckinClaim: new ApostatudoApiPostDailyCheckinClaimAdapter(),
  apiFetchPlayerProfile: new ApostatudoApiFetchPlayerProfileAdapter(),
  apiFetchOfficialProfiles: new ApostatudoApiFetchOfficialProfilesAdapter(),
  apiFetchOfficialProfile: new ApostatudoApiFetchOfficialProfileAdapter(),
  apiFetchCategoryGames: new ApostatudoApiFetchCategoryGamesAdapter(),
  apiSyncCrmLevel: new ApostatudoApiPostSyncCrmLevelAdapter(),
  apiFetchCrashPreGame: new ApostatudoApiFetchCrashPreGameAdapter(),
  apiFetchSiteStatus: new ApostatudoApiFetchSiteStatusAdapter(),
};

export type AdapterMap = {
  apiFetchStories: ApiFetchStoriesPort;
  apiRegisterUserJourneyEvent: ApiRegisterUserJourneyEventPort;
  deviceFingerprint: DeviceFingerprintPort;
  apiFetchLastGames: ApiFetchLastGamesPort;
  apiUpdateLastGames: ApiUpdateLastGamesPort;
  apiFetchBanners: ApiFetchBannersPort;
  apiFetchHomeSections: ApiFetchHomeSectionsPort;
  apiFetchGameFilters: ApiFetchGameFiltersPort;
  apiFetchGameFilterOptions: ApiFetchGameFilterOptionsPort;
  apiFetchPerfilOficialBanners: ApiFetchPerfilOficialBannersPort;
  apiFetchHomeMenu: ApiFetchHomeMenuPort;
  apiFetchCuratedEvents: ApiFetchCuratedEventsPort;
  apiFetchFaq: ApiFetchFaqPort;
  apiFetchBlogPosts: ApiFetchBlogPostsPort;
  apiFetchBlogPost: ApiFetchBlogPostPort;
  apiRedeemPromocode: ApiRedeemPromocodePort;
  apiSmarticoProfileEvent: ApiSmarticoProfileEventPort;
  apiFetchRoulettes: ApiFetchRoulettesPort;
  apiFetchRouletteDetail: ApiFetchRouletteDetailPort;
  apiPostRouletteSpin: ApiPostRouletteSpinPort;
  apiFetchRoulettePrizeHistory: ApiFetchRoulettePrizeHistoryPort;
  apiFetchLoyaltyHub: ApiFetchLoyaltyHubPort;
  apiFetchDailyCheckin: ApiFetchDailyCheckinPort;
  apiPostDailyCheckinClaim: ApiPostDailyCheckinClaimPort;
  apiFetchPlayerProfile: ApiFetchPlayerProfilePort;
  apiFetchOfficialProfiles: ApiFetchOfficialProfilesPort;
  apiFetchOfficialProfile: ApiFetchOfficialProfilePort;
  apiFetchCategoryGames: ApiFetchCategoryGamesPort;
  apiSyncCrmLevel: ApiSyncCrmLevelPort;
  apiFetchCrashPreGame: ApiFetchCrashPreGamePort;
  apiFetchSiteStatus: ApiFetchSiteStatusPort;
};

export function resolveAdapter<K extends keyof AdapterMap>(
  key: K,
): AdapterMap[K] {
  return adapterRegistry[key] as AdapterMap[K];
}
